webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(1);
	
	var _react = __webpack_require__(191);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(343);
	
	var _reactRedux = __webpack_require__(344);
	
	var _reactRouter = __webpack_require__(365);
	
	var _routes = __webpack_require__(422);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(690);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var App = _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: _store2.default },
	    _react2.default.createElement(
	        _reactRouter.Router,
	        { history: _reactRouter.hashHistory },
	        _routes2.default
	    )
	);
	
	(0, _reactDom.render)(App, document.getElementById("root"));

/***/ },

/***/ 422:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(191);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(365);
	
	var _root = __webpack_require__(423);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _home = __webpack_require__(526);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createElement(
	    _reactRouter.Route,
	    { component: _root2.default, path: "/" },
	    _react2.default.createElement(_reactRouter.IndexRoute, { component: _home2.default })
	);

/***/ },

/***/ 423:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _radium = __webpack_require__(424);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _react = __webpack_require__(191);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(472);
	
	var _header = __webpack_require__(523);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _spacer = __webpack_require__(525);
	
	var _spacer2 = _interopRequireDefault(_spacer);
	
	var _colors = __webpack_require__(524);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleRules = {
	    root: {
	        body: {
	            margin: "0px",
	            fontFamily: "roboto",
	            fontWeight: 300,
	            fontSize: "16px",
	            color: _colors2.default.primaryText
	        }
	    }
	};
	var styles = {
	    root: {
	        width: "622px",
	        position: "absolute",
	        top: "100px",
	        left: "calc(50% - 311px)",
	        marginBottom: "100px"
	    }
	};
	
	var Root = _react2.default.createClass({
	    displayName: "Root",
	
	    propTypes: (0, _tcombReact.propTypes)({
	        children: _tcombReact.t.ReactNode
	    }, { strict: false }),
	
	    render: function render() {
	        return _react2.default.createElement(
	            "div",
	            { style: styles.root },
	            _react2.default.createElement(_radium.Style, { rules: styleRules.root }),
	            _react2.default.createElement(_header2.default, null),
	            _react2.default.createElement(_spacer2.default, { direction: "v", size: 45 }),
	            this.props.children
	        );
	    }
	});
	
	exports.default = (0, _radium2.default)(Root);

/***/ },

/***/ 523:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(191);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colors = __webpack_require__(524);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	    container: {
	        display: "flex",
	        justifyContent: "space-between",
	        alignItems: "flex-end"
	    },
	    logo: {
	        fontFamily: "Montserrat",
	        fontSize: "47px",
	        textDecoration: "underline",
	        color: _colors2.default.accent
	    },
	    motto: {
	        fontSize: "16.5px",
	        color: _colors2.default.secondaryText,
	        paddingBottom: "10px"
	    }
	};
	
	var Header = _react2.default.createClass({
	    displayName: "Header",
	    render: function render() {
	        return _react2.default.createElement(
	            "div",
	            { style: styles.container },
	            _react2.default.createElement(
	                "div",
	                { style: styles.logo },
	                "Shooooort"
	            ),
	            _react2.default.createElement(
	                "div",
	                { style: styles.motto },
	                "The url shortener with a long name"
	            )
	        );
	    }
	});
	
	exports.default = Header;

/***/ },

/***/ 524:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    primaryText: "#555555",
	    secondaryText: "#aaaaaa",
	    unimportantText: "#cccccc",
	    disabledButtonText: "#bfbfbf",
	    disabledButtonBackground: "#e0e0e0",
	    lightBackgorund: "#eaeaea",
	    accent: "#eb4a42",
	    white: "#ffffff"
	};

/***/ },

/***/ 525:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(191);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(472);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Spacer = _react2.default.createClass({
	    displayName: "Spacer",
	
	    propTypes: (0, _tcombReact.propTypes)({
	        direction: _tcombReact.t.enums.of(["h", "v"]),
	        size: _tcombReact.t.Number
	    }, { strict: false }),
	
	    renderH: function renderH() {
	        return _react2.default.createElement("span", {
	            style: {
	                display: "inline-block",
	                width: this.props.size + "px"
	            }
	        });
	    },
	    renderV: function renderV() {
	        return _react2.default.createElement("div", {
	            style: {
	                width: "100%",
	                height: this.props.size + "px"
	            }
	        });
	    },
	    render: function render() {
	        return this.props.direction === "h" ? this.renderH() : this.renderV();
	    }
	});
	
	exports.default = Spacer;

/***/ },

/***/ 526:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ramda = __webpack_require__(527);
	
	var _react = __webpack_require__(191);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(344);
	
	var _tcombReact = __webpack_require__(472);
	
	var _dropCodesCollection = __webpack_require__(528);
	
	var _dropCodesCollection2 = _interopRequireDefault(_dropCodesCollection);
	
	var _getCodesCollection = __webpack_require__(530);
	
	var _getCodesCollection2 = _interopRequireDefault(_getCodesCollection);
	
	var _shortenUrl = __webpack_require__(553);
	
	var _shortenUrl2 = _interopRequireDefault(_shortenUrl);
	
	var _codesList = __webpack_require__(554);
	
	var _codesList2 = _interopRequireDefault(_codesList);
	
	var _spacer = __webpack_require__(525);
	
	var _spacer2 = _interopRequireDefault(_spacer);
	
	var _urlForm = __webpack_require__(684);
	
	var _urlForm2 = _interopRequireDefault(_urlForm);
	
	var _appTcombTypes = __webpack_require__(582);
	
	var _colors = __webpack_require__(524);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	    listHeadingContainer: {
	        display: "flex",
	        alignItems: "flex-end"
	    },
	    listHeading: {
	        fontSize: "22px"
	    },
	    clearHistoryButton: {
	        border: "0px",
	        backgroundColor: _colors2.default.white,
	        color: _colors2.default.accent,
	        fontSize: "16px",
	        cursor: "pointer",
	        paddingBottom: "2px"
	    }
	};
	
	var Home = _react2.default.createClass({
	    displayName: "Home",
	
	    propTypes: (0, _tcombReact.propTypes)({
	        codes: _appTcombTypes.CodesCollection,
	        dropCodesCollection: _tcombReact.t.Function,
	        getCodesCollection: _tcombReact.t.Function,
	        shortenUrl: _tcombReact.t.Function
	    }, { strict: false }),
	
	    componentWillMount: function componentWillMount() {
	        this.props.getCodesCollection();
	    },
	    render: function render() {
	        var _props = this.props;
	        var codes = _props.codes;
	        var dropCodesCollection = _props.dropCodesCollection;
	        var shortenUrl = _props.shortenUrl;
	
	        return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_urlForm2.default, { onSubmit: shortenUrl }),
	            _react2.default.createElement(_spacer2.default, { direction: "v", size: 75 }),
	            _react2.default.createElement(
	                "div",
	                { style: styles.listHeadingContainer },
	                _react2.default.createElement(
	                    "div",
	                    { style: styles.listHeading },
	                    "Previously shortened by you"
	                ),
	                _react2.default.createElement(_spacer2.default, { direction: "h", size: 10 }),
	                _react2.default.createElement(
	                    "button",
	                    {
	                        onClick: dropCodesCollection,
	                        style: styles.clearHistoryButton
	                    },
	                    "Clear history"
	                )
	            ),
	            _react2.default.createElement(_spacer2.default, { direction: "v", size: 50 }),
	            _react2.default.createElement(_codesList2.default, { codes: codes })
	        );
	    }
	});
	
	function mapStateToProps(state) {
	    return {
	        codes: state.codes
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dropCodesCollection: (0, _ramda.pipe)(_dropCodesCollection2.default, dispatch),
	        getCodesCollection: (0, _ramda.pipe)(_getCodesCollection2.default, dispatch),
	        shortenUrl: (0, _ramda.pipe)(_shortenUrl2.default, dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Home);

/***/ },

/***/ 528:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DROP_CODES_COLLECTION_SUCCESS = undefined;
	exports.default = dropCodesCollection;
	
	var _codesCollection = __webpack_require__(529);
	
	var DROP_CODES_COLLECTION_SUCCESS = exports.DROP_CODES_COLLECTION_SUCCESS = "DROP_CODES_COLLECTION_SUCCESS";
	
	function dropCodesCollection() {
	    (0, _codesCollection.drop)();
	    return {
	        type: DROP_CODES_COLLECTION_SUCCESS,
	        payload: (0, _codesCollection.get)()
	    };
	}

/***/ },

/***/ 529:
/***/ function(module, exports) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.get = get;
	exports.insert = insert;
	exports.drop = drop;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var LOCALSTORAGE_KEY = "codes";
	function getCollection() {
	    return JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY) || "{}");
	}
	function setCollection(db) {
	    localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(db));
	}
	
	function get() {
	    return getCollection();
	}
	
	function insert(_ref) {
	    var code = _ref.code;
	    var url = _ref.url;
	
	    setCollection(_extends({}, getCollection(), _defineProperty({}, code, { code: code, url: url })));
	}
	
	function drop() {
	    setCollection({});
	}

/***/ },

/***/ 530:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GET_CODES_COLLECTION_SUCCESS = undefined;
	exports.default = getCodesCollection;
	
	var _ramda = __webpack_require__(527);
	
	var _getCodeStats = __webpack_require__(531);
	
	var _getCodeStats2 = _interopRequireDefault(_getCodeStats);
	
	var _codesCollection = __webpack_require__(529);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { return step("next", value); }, function (err) { return step("throw", err); }); } } return step("next"); }); }; }
	
	var GET_CODES_COLLECTION_SUCCESS = exports.GET_CODES_COLLECTION_SUCCESS = "GET_CODES_COLLECTION_SUCCESS";
	
	function getCodesCollection() {
	    var _this2 = this;
	
	    return function () {
	        var ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch) {
	            var codesCollection;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            codesCollection = (0, _codesCollection.get)();
	
	                            dispatch({
	                                type: GET_CODES_COLLECTION_SUCCESS,
	                                payload: codesCollection
	                            });
	                            (0, _ramda.values)(codesCollection).forEach(function (code) {
	                                return dispatch((0, _getCodeStats2.default)(code.code));
	                            });
	
	                        case 3:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2);
	        })),
	            _this = _this2;
	
	        return function (_x) {
	            return ref.apply(_this, arguments);
	        };
	    }();
	}

/***/ },

/***/ 531:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GET_CODE_STATS_ERROR = exports.GET_CODE_STATS_SUCCESS = exports.GET_CODE_STATS_START = undefined;
	exports.default = getCodeStats;
	
	var _bluebird = __webpack_require__(532);
	
	var _axios = __webpack_require__(534);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GET_CODE_STATS_START = exports.GET_CODE_STATS_START = "GET_CODE_STATS_START";
	var GET_CODE_STATS_SUCCESS = exports.GET_CODE_STATS_SUCCESS = "GET_CODE_STATS_SUCCESS";
	var GET_CODE_STATS_ERROR = exports.GET_CODE_STATS_ERROR = "GET_CODE_STATS_ERROR";
	
	function getCodeStats(code) {
	    return function (dispatch) {
	        return (0, _bluebird.resolve)().then(function () {
	            dispatch({
	                type: GET_CODE_STATS_START,
	                meta: { code: code }
	            });
	            return _axios2.default.get("/" + code + "/stats");
	        }).then(function (res) {
	            dispatch({
	                type: GET_CODE_STATS_SUCCESS,
	                payload: res.data,
	                meta: { code: code }
	            });
	        }).catch(function (err) {
	            /*
	            *   We want to dispatch a GET_CODE_STATS_ERROR action only when
	            *   `axios.get` fails (the error is an AxiosError). In all other
	            *   cases we rethrow the error.
	            */
	            if (err instanceof _axios.AxiosError) {
	                dispatch({
	                    type: GET_CODE_STATS_ERROR,
	                    payload: err,
	                    error: true,
	                    meta: { code: code }
	                });
	            } else {
	                throw err;
	            }
	        }).catch(function (err) {
	            /*
	            *   We cannot recover from a dispatch error. Therefore we
	            *   only log it.
	            */
	            console.error(err);
	        });
	    };
	}

/***/ },

/***/ 534:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AxiosError = undefined;
	
	var _axios = __webpack_require__(535);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(552);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AxiosError = exports.AxiosError = function AxiosError(err) {
	    _classCallCheck(this, AxiosError);
	
	    this.name = "AxiosError";
	    this.err = err;
	};
	
	var axiosInstance = _axios2.default.create({
	    baseURL: _config.API_URL,
	    timeout: 5000
	});
	function rethrowAxiosError(err) {
	    throw new AxiosError(err);
	}
	function get() {
	    return axiosInstance.get.apply(axiosInstance, arguments).catch(rethrowAxiosError);
	}
	function post() {
	    return axiosInstance.post.apply(axiosInstance, arguments).catch(rethrowAxiosError);
	}
	
	exports.default = { get: get, post: post };

/***/ },

/***/ 552:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var API_URL = exports.API_URL = window.APP_CONFIG.API_URL;

/***/ },

/***/ 553:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SHORTENED_URL_AGED = exports.SHORTEN_URL_ERROR = exports.SHORTEN_URL_SUCCESS = exports.SHORTEN_URL_START = undefined;
	exports.default = shortenUrl;
	
	var _bluebird = __webpack_require__(532);
	
	var _axios = __webpack_require__(534);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _codesCollection = __webpack_require__(529);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SHORTEN_URL_START = exports.SHORTEN_URL_START = "SHORTEN_URL_START";
	var SHORTEN_URL_SUCCESS = exports.SHORTEN_URL_SUCCESS = "SHORTEN_URL_SUCCESS";
	var SHORTEN_URL_ERROR = exports.SHORTEN_URL_ERROR = "SHORTEN_URL_ERROR";
	
	var AGING_TIME_IN_MS = 10 * 1000;
	var SHORTENED_URL_AGED = exports.SHORTENED_URL_AGED = "SHORTENED_URL_AGED";
	
	function shortenUrl(url) {
	    return function (dispatch) {
	        return (0, _bluebird.resolve)().then(function () {
	            dispatch({ type: SHORTEN_URL_START });
	            return _axios2.default.post("/shorten", { url: url });
	        }).then(function (res) {
	            var code = {
	                code: res.data.shortcode,
	                url: url
	            };
	            (0, _codesCollection.insert)(code);
	            dispatch({ type: SHORTEN_URL_SUCCESS, payload: code });
	            return code;
	        }).delay(AGING_TIME_IN_MS).then(function (code) {
	            dispatch({ type: SHORTENED_URL_AGED, payload: code });
	        }).catch(function (err) {
	            /*
	            *   We want to dispatch a GET_CODE_STATS_ERROR action only when
	            *   `axios.post` fails (the error is an AxiosError). In all
	            *   other cases we rethrow the error.
	            */
	            if (err instanceof _axios.AxiosError) {
	                dispatch({
	                    type: SHORTEN_URL_ERROR,
	                    payload: err,
	                    error: true
	                });
	            } else {
	                throw err;
	            }
	        }).catch(function (err) {
	            /*
	            *   We cannot recover from a dispatch error. Therefore we
	            *   only log it.
	            */
	            console.error(err);
	        });
	    };
	}

/***/ },

/***/ 554:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _copyToClipboard = __webpack_require__(555);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _radium = __webpack_require__(424);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _ramda = __webpack_require__(527);
	
	var _react = __webpack_require__(191);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(472);
	
	var _config = __webpack_require__(552);
	
	var _asyncResultWrapper = __webpack_require__(557);
	
	var _asyncResultWrapper2 = _interopRequireDefault(_asyncResultWrapper);
	
	var _spacer = __webpack_require__(525);
	
	var _spacer2 = _interopRequireDefault(_spacer);
	
	var _appTcombTypes = __webpack_require__(582);
	
	var _colors = __webpack_require__(524);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _utils = __webpack_require__(584);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleRules = {
	    codeEntry: {
	        ".code-entry .click-to-copy-button": {
	            display: "none"
	        },
	        ".code-entry:hover .click-to-copy-button": {
	            display: "initial"
	        }
	    }
	};
	var styles = {
	    listContainer: {
	        tableLayout: "fixed",
	        width: "100%",
	        cursor: "pointer"
	    },
	    baseHeadColumn: {
	        color: _colors2.default.unimportantText,
	        fontSize: "14px",
	        textTransform: "uppercase"
	    },
	    linkColumnHeader: {
	        textAlign: "left"
	    },
	    visitsHeadColumn: {
	        textAlign: "center",
	        width: "80px"
	    },
	    lastVisitedHeadColumn: {
	        textAlign: "center",
	        width: "120px"
	    },
	    codeEntryContainer: {
	        height: "80px"
	    },
	    newlyCreatedHighlightContainer: {
	        position: "relative"
	    },
	    newlyCreatedHighlightBar: {
	        height: "80px",
	        width: "4px",
	        backgroundColor: _colors2.default.accent,
	        opacity: 0,
	        transition: "opacity 0.5s",
	        position: "absolute",
	        left: "-20px",
	        top: "-20px"
	    },
	    showHiglight: {
	        opacity: 1
	    },
	    shortUrlPrefix: {
	        fontWeight: 400
	    },
	    shortUrlCode: {
	        fontWeight: 400,
	        color: _colors2.default.accent
	    },
	    clickToCopyButton: {
	        float: "right",
	        color: _colors2.default.accent,
	        paddingRight: "30px"
	    },
	    fullUrl: {
	        color: _colors2.default.unimportantText,
	        overflow: "hidden",
	        textOverflow: "ellipsis",
	        whiteSpace: "nowrap",
	        paddingRight: "30px"
	    },
	    visitsBodyColumn: {
	        textAlign: "center"
	    },
	    lastVisitedBodyColumn: {
	        textAlign: "center"
	    }
	};
	
	var CodesList = _react2.default.createClass({
	    displayName: "CodesList",
	
	    propTypes: (0, _tcombReact.propTypes)({
	        codes: _appTcombTypes.CodesCollection
	    }),
	
	    handleClick: function handleClick(code) {
	        return function () {
	            (0, _copyToClipboard2.default)(_config.API_URL + "/" + code.code);
	        };
	    },
	    renderCodeEntry: function renderCodeEntry(code) {
	        var redirectCount = code.stats && code.stats.redirectCount || 0;
	        var lastVisit = redirectCount === 0 ? "Never" : (0, _utils.timeago)(code.stats && code.stats.lastSeenDate);
	        return _react2.default.createElement(
	            "tr",
	            {
	                className: "code-entry",
	                key: code.code,
	                onClick: this.handleClick(code),
	                style: styles.codeEntryContainer
	            },
	            _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { style: styles.newlyCreatedHighlightContainer },
	                    _react2.default.createElement("div", {
	                        style: [styles.newlyCreatedHighlightBar, code.newlyCreated ? styles.showHiglight : null]
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        { style: styles.shortUrlPrefix },
	                        "shooooort.com/"
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { style: styles.shortUrlCode },
	                        code.code
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        {
	                            className: "click-to-copy-button",
	                            style: styles.clickToCopyButton
	                        },
	                        "Click to copy this link"
	                    )
	                ),
	                _react2.default.createElement(_spacer2.default, { direction: "v", size: 2 }),
	                _react2.default.createElement(
	                    "div",
	                    { style: styles.fullUrl },
	                    code.url
	                )
	            ),
	            _react2.default.createElement(
	                "td",
	                { style: styles.visitsBodyColumn },
	                _react2.default.createElement(
	                    _asyncResultWrapper2.default,
	                    {
	                        error: !!code.errorFetchingStats,
	                        loading: code.fetchingStats
	                    },
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        redirectCount
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "td",
	                { style: styles.lastVisitedBodyColumn },
	                _react2.default.createElement(
	                    _asyncResultWrapper2.default,
	                    {
	                        error: !!code.errorFetchingStats,
	                        loading: code.fetchingStats
	                    },
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        lastVisit
	                    )
	                )
	            )
	        );
	    },
	    render: function render() {
	        return _react2.default.createElement(
	            "table",
	            { style: styles.listContainer },
	            _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                        "th",
	                        { style: [styles.baseHeadColumn, styles.linkColumnHeader] },
	                        "link"
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        { style: [styles.baseHeadColumn, styles.visitsHeadColumn] },
	                        "visits"
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        { style: [styles.baseHeadColumn, styles.lastVisitedHeadColumn] },
	                        "last visited"
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "tbody",
	                null,
	                _react2.default.createElement(_radium.Style, { rules: styleRules.codeEntry }),
	                (0, _ramda.values)(this.props.codes).map(this.renderCodeEntry)
	            )
	        );
	    }
	});
	
	exports.default = (0, _radium2.default)(CodesList);

/***/ },

/***/ 557:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _halogen = __webpack_require__(558);
	
	var _react = __webpack_require__(191);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(472);
	
	var _icon = __webpack_require__(581);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _colors = __webpack_require__(524);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AsyncResultWrapper = _react2.default.createClass({
	    displayName: "AsyncResultWrapper",
	
	    propTypes: (0, _tcombReact.propTypes)({
	        children: _tcombReact.t.maybe(_tcombReact.t.ReactChildren),
	        loading: _tcombReact.t.maybe(_tcombReact.t.Boolean),
	        error: _tcombReact.t.maybe(_tcombReact.t.Boolean)
	    }),
	
	    render: function render() {
	        var _props = this.props;
	        var children = _props.children;
	        var error = _props.error;
	        var loading = _props.loading;
	
	        if (loading) {
	            return _react2.default.createElement(_halogen.BeatLoader, { color: _colors2.default.accent, size: "10px" });
	        }
	        if (error) {
	            return _react2.default.createElement(_icon2.default, { color: _colors2.default.accent, icon: "exclamation-circle" });
	        }
	        return _react2.default.Children.only(children);
	    }
	});
	
	exports.default = AsyncResultWrapper;

/***/ },

/***/ 581:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ramda = __webpack_require__(527);
	
	var _react = __webpack_require__(191);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(472);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Icon = _react2.default.createClass({
	    displayName: "Icon",
	
	    propTypes: (0, _tcombReact.propTypes)({
	        className: _tcombReact.t.maybe(_tcombReact.t.String),
	        color: _tcombReact.t.maybe(_tcombReact.t.String),
	        icon: _tcombReact.t.String,
	        onClick: _tcombReact.t.maybe(_tcombReact.t.Function),
	        size: _tcombReact.t.maybe(_tcombReact.t.String),
	        spin: _tcombReact.t.maybe(_tcombReact.t.Boolean),
	        style: _tcombReact.t.maybe(_tcombReact.t.Object)
	    }),
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            color: undefined,
	            onClick: undefined,
	            size: undefined,
	            spin: false,
	            style: {}
	        };
	    },
	    getClassName: function getClassName() {
	        var _props = this.props;
	        var className = _props.className;
	        var icon = _props.icon;
	        var spin = _props.spin;
	
	        return [
	        // FontAwesome icon class
	        "fa fa-" + icon,
	        // FontAwesome spin class
	        spin ? "fa-spin" : undefined, className].filter(_ramda.identity).join(" ");
	    },
	    getStyle: function getStyle() {
	        var _props2 = this.props;
	        var color = _props2.color;
	        var onClick = _props2.onClick;
	        var size = _props2.size;
	        var style = _props2.style;
	
	        return (0, _ramda.pickBy)(_ramda.identity, _extends({
	            color: color,
	            cursor: onClick ? "pointer" : undefined,
	            fontSize: size
	        }, style));
	    },
	    render: function render() {
	        var onClick = this.props.onClick;
	
	        return _react2.default.createElement("i", {
	            className: this.getClassName(),
	            onClick: onClick,
	            style: this.getStyle()
	        });
	    }
	});
	
	exports.default = Icon;

/***/ },

/***/ 582:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CodesCollection = exports.Code = exports.URLString = exports.ISO8601String = undefined;
	
	var _tcombReact = __webpack_require__(472);
	
	var _validator = __webpack_require__(583);
	
	var ISO8601String = exports.ISO8601String = _tcombReact.t.refinement(_tcombReact.t.String, _validator.isISO8601);
	var URLString = exports.URLString = _tcombReact.t.refinement(_tcombReact.t.String, _validator.isURL);
	
	var Code = exports.Code = _tcombReact.t.struct({
	    code: _tcombReact.t.String,
	    url: URLString,
	    fetchingStats: _tcombReact.t.Boolean,
	    errorFetchingStats: _tcombReact.t.maybe(_tcombReact.t.Object),
	    newlyCreated: _tcombReact.t.Boolean,
	    stats: _tcombReact.t.maybe(_tcombReact.t.struct({
	        startDate: ISO8601String,
	        lastSeenDate: ISO8601String,
	        redirectCount: _tcombReact.t.Number
	    }))
	}, "Code");
	
	var CodesCollection = exports.CodesCollection = _tcombReact.t.dict(_tcombReact.t.String, Code, "CodesCollection");

/***/ },

/***/ 584:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.timeago = timeago;
	exports.urlIsValid = urlIsValid;
	
	var _moment = __webpack_require__(585);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _validator = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function timeago(date) {
	    return (0, _moment2.default)(date || undefined).fromNow();
	}
	
	function urlIsValid(url) {
	    return (0, _validator.isURL)(url, {
	        protocols: ["http", "https"],
	        require_protocol: true,
	        require_valid_protocol: true
	    });
	}

/***/ },

/***/ 684:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _radium = __webpack_require__(424);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _react = __webpack_require__(191);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsLinkedStateMixin = __webpack_require__(685);
	
	var _reactAddonsLinkedStateMixin2 = _interopRequireDefault(_reactAddonsLinkedStateMixin);
	
	var _tcombReact = __webpack_require__(472);
	
	var _spacer = __webpack_require__(525);
	
	var _spacer2 = _interopRequireDefault(_spacer);
	
	var _colors = __webpack_require__(524);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _measures = __webpack_require__(689);
	
	var _measures2 = _interopRequireDefault(_measures);
	
	var _utils = __webpack_require__(584);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	    container: {
	        display: "flex"
	    },
	    input: {
	        flexGrow: 1,
	        border: "0px",
	        borderRadius: _measures2.default.borderRadiusPx,
	        backgroundColor: _colors2.default.lightBackgorund,
	        fontSize: "16px",
	        paddingLeft: "20px",
	        paddingRight: "20px",
	        outline: "none"
	    },
	    submitButtonBase: {
	        width: "150px",
	        height: "38px",
	        fontSize: "16px",
	        border: "0px",
	        borderRadius: _measures2.default.borderRadiusPx
	    },
	    submitButtonDisabled: {
	        backgroundColor: _colors2.default.disabledButtonBackground,
	        color: _colors2.default.disabledButtonText,
	        cursor: "not-allowed"
	    },
	    submitButtonEnabled: {
	        backgroundColor: _colors2.default.accent,
	        color: _colors2.default.white,
	        cursor: "pointer"
	    }
	};
	
	var UrlForm = _react2.default.createClass({
	    displayName: "UrlForm",
	
	    propTypes: (0, _tcombReact.propTypes)({
	        onSubmit: _tcombReact.t.Function
	    }, { strict: false }),
	
	    mixins: [_reactAddonsLinkedStateMixin2.default],
	
	    getInitialState: function getInitialState() {
	        return {};
	    },
	    handleSubmit: function handleSubmit(e) {
	        e.preventDefault();
	        this.props.onSubmit(this.state.url);
	        this.replaceState({});
	    },
	    render: function render() {
	        var urlValid = (0, _utils.urlIsValid)(this.state.url);
	        return _react2.default.createElement(
	            "form",
	            { onSubmit: this.handleSubmit, style: styles.container },
	            _react2.default.createElement("input", {
	                placeholder: "Paste the link you want to shorten here",
	                style: styles.input,
	                type: "text",
	                valueLink: this.linkState("url")
	            }),
	            _react2.default.createElement(_spacer2.default, { direction: "h", size: 15 }),
	            _react2.default.createElement(
	                "button",
	                {
	                    disabled: !urlValid,
	                    style: [styles.submitButtonBase, urlValid ? styles.submitButtonEnabled : styles.submitButtonDisabled],
	                    type: "submit"
	                },
	                "Shorten this link"
	            )
	        );
	    }
	});
	
	exports.default = (0, _radium2.default)(UrlForm);

/***/ },

/***/ 689:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ramda = __webpack_require__(527);
	
	var px = function px(_ref) {
	    var _ref2 = _slicedToArray(_ref, 2);
	
	    var key = _ref2[0];
	    var value = _ref2[1];
	    return [key + "Px", value + "px"];
	};
	var convert = (0, _ramda.pipe)(_ramda.toPairs, (0, _ramda.map)(px), _ramda.fromPairs);
	
	var measures = {
	    borderRadius: 3
	};
	
	exports.default = _extends({}, measures, convert(measures));

/***/ },

/***/ 690:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRouter = __webpack_require__(365);
	
	var _reactRouterRedux = __webpack_require__(691);
	
	var _redux = __webpack_require__(350);
	
	var _reduxLogger = __webpack_require__(692);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _reduxThunk = __webpack_require__(693);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(694);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reduxRouterMiddleware = (0, _reactRouterRedux.syncHistory)(_reactRouter.hashHistory);
	
	var middleware = (0, _redux.applyMiddleware)(reduxRouterMiddleware, _reduxThunk2.default, (0, _reduxLogger2.default)({ collapsed: true }));
	
	exports.default = (0, _redux.compose)(middleware)(_redux.createStore)(_reducers2.default);

/***/ },

/***/ 694:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(350);
	
	var _reactRouterRedux = __webpack_require__(691);
	
	var _codes = __webpack_require__(695);
	
	var _codes2 = _interopRequireDefault(_codes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	    codes: _codes2.default,
	    routing: _reactRouterRedux.routeReducer
	});

/***/ },

/***/ 695:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = codes;
	
	var _ramda = __webpack_require__(527);
	
	var _dropCodesCollection = __webpack_require__(528);
	
	var _getCodesCollection = __webpack_require__(530);
	
	var _getCodeStats = __webpack_require__(531);
	
	var _shortenUrl = __webpack_require__(553);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function codes() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var _ref = arguments[1];
	    var type = _ref.type;
	    var payload = _ref.payload;
	    var meta = _ref.meta;
	
	    switch (type) {
	        case _dropCodesCollection.DROP_CODES_COLLECTION_SUCCESS:
	            return {};
	        case _getCodesCollection.GET_CODES_COLLECTION_SUCCESS:
	            return (0, _ramda.map)(function (code) {
	                return _extends({}, code, {
	                    fetchingStats: false,
	                    errorFetchingStats: null,
	                    newlyCreated: false,
	                    stats: null
	                });
	            }, payload);
	        case _getCodeStats.GET_CODE_STATS_START:
	            return _extends({}, state, _defineProperty({}, meta.code, _extends({}, state[meta.code], {
	                fetchingStats: true,
	                errorFetchingStats: null,
	                stats: null
	            })));
	        case _getCodeStats.GET_CODE_STATS_SUCCESS:
	            return _extends({}, state, _defineProperty({}, meta.code, _extends({}, state[meta.code], {
	                fetchingStats: false,
	                errorFetchingStats: null,
	                stats: payload
	            })));
	        case _getCodeStats.GET_CODE_STATS_ERROR:
	            return _extends({}, state, _defineProperty({}, meta.code, _extends({}, state[meta.code], {
	                fetchingStats: false,
	                errorFetchingStats: payload,
	                stats: null
	            })));
	        case _shortenUrl.SHORTEN_URL_SUCCESS:
	            return _extends({}, state, _defineProperty({}, payload.code, _extends({}, payload, {
	                fetchingStats: false,
	                errorFetchingStats: null,
	                newlyCreated: true,
	                stats: null
	            })));
	        case _shortenUrl.SHORTENED_URL_AGED:
	            return _extends({}, state, _defineProperty({}, payload.code, _extends({}, state[payload.code], {
	                newlyCreated: false
	            })));
	        default:
	            return state;
	    }
	}

/***/ }

});


/** WEBPACK FOOTER **
 ** ./build/_assets/js/app.js
 **/